import {AutomationOutputFileConfigGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileConfigGraphQL';
import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';

export function isFolderRequiredForOutputFile(
  automationOutputFileConfig: AutomationOutputFileConfigGraphQL
): boolean {
  const tagSchemaInfo = automationOutputFileConfig.tagSchemaInfo;
  if (
    tagSchemaInfo != null &&
    // sourceId/folderId is not present in configs versioned before per-file folder selection
    // but we don't want to show folder picker for those configs
    tagSchemaInfo.hasOwnProperty('sourceId') &&
    tagSchemaInfo.sourceId == null
  ) {
    // Check both REST format (folderId) and GraphQL format (folder.id)
    // Folder is NOT required if either format has a value set
    const hasFolderIdProperty = tagSchemaInfo.hasOwnProperty('folderId');
    const hasFolderProperty = tagSchemaInfo.hasOwnProperty('folder');

    // REST format check
    const folderId = hasFolderIdProperty
      ? (tagSchemaInfo as unknown as {folderId?: string}).folderId
      : undefined;

    // GraphQL format check
    const folderGraphQLId = hasFolderProperty ? tagSchemaInfo.folder?.id : undefined;

    // Folder is NOT required if either format has a value
    if (folderId || folderGraphQLId) {
      return false;
    }

    // Folder IS required if either format exists and has null/undefined value
    if (hasFolderIdProperty || hasFolderProperty) {
      return true;
    }
  }
  const destinationInfo = automationOutputFileConfig.destinationInfo;
  if (destinationInfo != null && destinationInfo.sourceId == null) {
    return true;
  }
  return false;
}

export function isLocationRequiredForOutputFile(
  automationOutputFileConfig: AutomationOutputFileConfigGraphQL
): boolean {
  const destinationInfo = automationOutputFileConfig.destinationInfo;
  // Check both GraphQL format (location.id) and REST format (locationId)
  return (
    destinationInfo != null &&
    destinationInfo.location?.id == null &&
    (destinationInfo as unknown as {locationId?: string}).locationId == null
  );
}

export function isOutputFileMissingFolder(automationOutputFile: AutomationOutputFileGraphQL): boolean {
  return (
    isFolderRequiredForOutputFile(automationOutputFile.automationOutputFileConfig) &&
    !automationOutputFile.folderId
  );
}

export function isOutputFileMissingLocation(automationOutputFile: AutomationOutputFileGraphQL): boolean {
  return (
    isLocationRequiredForOutputFile(automationOutputFile.automationOutputFileConfig) &&
    !automationOutputFile.locationId
  );
}

export function isOutputFileMissingFolderOrLocation(
  automationOutputFile: AutomationOutputFileGraphQL
): boolean {
  return isOutputFileMissingFolder(automationOutputFile) || isOutputFileMissingLocation(automationOutputFile);
}
